import React from 'react';

interface SpinnerProps {
  /** Visible loading label. Default: "Loading..." */
  label?: string;
  /** Show as a centered full-page spinner. Default: false. */
  fullPage?: boolean;
}

const Spinner: React.FC<SpinnerProps> = ({ label = 'Loading...', fullPage = false }) => {
  const spinner = (
    <div role="status" aria-label={label} className="flex flex-col items-center gap-3">
      <div className="animate-spin rounded-full h-10 w-10 border-2 border-brand-200 dark:border-brand-900" style={{ borderTopColor: 'var(--sidebar-link-active-bg)' }}></div>
      <span className="text-xs font-medium" style={{ color: 'var(--text-muted)' }}>{label}</span>
    </div>
  );

  if (fullPage) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--page-bg)' }}>
        {spinner}
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center p-8">
      {spinner}
    </div>
  );
};

export default Spinner;
